// Тосты живут поверх окон и панелей (ux.md, раздел 2): «Отменить» и «Повторить» в тосте нажимаются,
// даже когда открыто окно или панель на весь экран. Нажатие в тосте — не «клик мимо» окна:
// окно от него не закрывается.
//
// Radix Dialog решает, был ли «клик мимо», уже после click (deferPointerDownOutside), а кнопка
// действия к этому времени закрыла свой тост: элемент нажатия вынут из страницы вместе с тостом,
// и области тостов среди его предков нет. Поэтому тост узнаётся и по самому тосту (.t-toast).

/** Событие «снаружи» слоя Radix пришло из области тостов или из тоста, который уже закрылся. */
export function isToastTarget(event: Event): boolean {
  const target = event.target;
  return target instanceof Element && target.closest('.kp-toasts, .t-toast') !== null;
}

/** Обработчик «снаружи» для окон: нажатие в тосте окно не закрывает. */
export function keepOpenForToasts(event: Event): void {
  if (isToastTarget(event)) event.preventDefault();
}
